"use strict";
import angular from "angular";

import tritonAdsLocationHtmlUrl from "./views/tritonGeo.html";

var app = angular.module("app.tritonGeoTargeting.component", []);

app.component("tritonGeoTargeting", {
  bindings: {
    selectedGeoLocations: "=",
    clusterId: "=",
    showActions: "=",
    isEditForm: "=",
  },
  templateUrl: tritonAdsLocationHtmlUrl,

  // The controller that handles our component logic
  controller: function (
    $rootScope,
    $scope,
    $ioAlert,
    anchorSmoothScroll,
    $location,
    $timeout,
    $stateParams,
    FormService,
    ClusterService,
    $modal,
    ModalService
  ) {
    var self = this;
    self.orderId = $stateParams.orderId;
    self.rootLocation = { id: 0, children: "1", criteria: "" };
    self.navAdwordsLocations = [];
    self.previousLocationData = [];
    self.geolocSearch = "";
    self.breadcrumbs = [];
    self.collectedNodes = [0];
    self.includeOrExcludeLocation = null;
    var geoLocationsCount = 0;
    self.showTabPanel = true;
    $rootScope.selectedGeoLocations = null;

    self.geoTextInputs = {
      inputValues: "",
    };
    self.textInputOptions = ["US Postal Codes", "US States", "US Cities"];
    self.textInputObj = {
      textInputType: "US Postal Codes",
    };
    self.selectedCriteria = {
      criteria: "",
    };
    self.criteria = ["include all", "exclude all"];
    self.showError = false;
    self.toggleComponent = function (selectedOption) {
      self.selectedInput.value = selectedOption;
    };
    $scope.$watch("$ctrl.geoTextInputs.inputValues", function () {
      if (self.geoTextInputs.inputValues.length == 0) {
        self.showError = false;
      }
    });

    self.handleChangeTextInput = function () {
      self.geoTextInputs.inputValues = "";
      self.showError = false;
    };

    self.getLocationTooltips = function (locations) {
      var data = angular.copy(locations);
      data = data.slice(2);
      var html = angular.element("<ul/>");
      angular.forEach(data, function (item) {
        html.append("<li style='list-style:none;'>" + item.full_name + "</li>");
      });
      return html.html();
    };

    self.handleClearSelectedLocations = function () {
      self.selectedGeoLocations.selAdwordsLocationPickers = [];
      self.selectedCriteria.criteria = "none";
      geoLocationsCount = 0;
      self.includeOrExcludeLocation = null;
      _.each(self.navAdwordsLocations, function (navLocation) {
        navLocation.criteria = "";
        navLocation.criteria_link = "include";
      });
    };

    $scope.$watch(
      function () {
        return self.selectedGeoLocations.selAdwordsLocationPickers;
      },
      function (newValue) {
        if (Array.isArray(newValue) && newValue.length > 0) {
          // Call the method to update criteria and criteria_link
          self.updateExcludedLocations(newValue);
        } else if (Array.isArray(newValue) && newValue.length === 0) {
          // Call the method when the array is empty
          self.handleClearSelectedLocations();
        }
      },
      true // Deep watch to detect changes within the array
    );

    self.updateExcludedLocations = function (selectedLocations) {
      selectedLocations.forEach((selected) => {
        const matchedLocation = self.navAdwordsLocations.find((location) => {
          return (
            location.name === selected.name &&
            location.type === selected.type &&
            location.country_code === selected.country_code &&
            (!selected.parent_name ||
              selected.parent_name === location.parent_name) &&
            (!selected.parent_region_name ||
              selected.parent_region_name === location.parent_region_name) &&
            (!selected.code || selected.code === location.code)
          );
        });

        // If we find the location, mark it as included
        if (matchedLocation) {
          matchedLocation.criteria = "include";
          matchedLocation.criteria_link = "included";
        }
      });

      self.previousLocationData = angular.copy(self.navAdwordsLocations);
    };

    self.handleChangeCriteria = function () {
      self.selectedGeoLocations.selAdwordsLocationPickers = [];
      if (self.selectedCriteria.criteria == "include all") {
        _.each(self.navAdwordsLocations, function (navLocation) {
          navLocation.criteria = "include";
          navLocation.criteria_link = "included";
          navLocation.full_name = self.buildFullName(navLocation);
          self.selectedGeoLocations.selAdwordsLocationPickers.push(navLocation);
        });
      } else if (self.selectedCriteria.criteria == "exclude all") {
        _.each(self.navAdwordsLocations, function (navLocation) {
          navLocation.criteria = "exclude";
          navLocation.criteria_link = "excluded";
          navLocation.full_name = self.buildFullName(navLocation);
          self.selectedGeoLocations.selAdwordsLocationPickers.push(navLocation);
        });
      } else {
        _.each(self.navAdwordsLocations, function (navLocation) {
          navLocation.criteria = "";
          navLocation.criteria_link = "include";
        });
      }
    };

    self.getChildrenNodes = function (item) {
      if (item.children > 0) {
        // if (self.collectedNodes.indexOf(item.country_code) < 0) {
        FormService.getTritonLocationsById(item.country_code).then(
          function (success) {
            self.collectedNodes.push(item.id);
            self.locations = success.data;
            self.getLocationChilds("BYID", item);
            self.geolocSearch = "";
          },
          function (error) {
            $ioAlert.show(
              "Error!",
              "Something went wrong here. Please refresh the page to try again",
              "error"
            );
          }
        );
      }
    };

    self.showtabPanel = function () {
      self.showTabPanel = !self.showTabPanel;
    };

    self.getLocationChilds = function (type, item) {
      if (item.children > 0) {
        self.navAdwordsLocations = [];
        if (type !== "BYID") {
          self.locations = self.locations.data;
        }
        if (self.locations) {
          for (var i = 0, len = self.locations.length; i < len; i++) {
            if (self.locations[i].parent_id == item.id) {
              // Assign default criteria if none exists
              if (!self.locations[i].criteria && item.criteria) {
                self.locations[i].criteria = item.criteria;
              }

              // Update criteria_link based on the current criteria value
              if (self.locations[i].criteria === "include") {
                self.locations[i].criteria_link = "included";
              } else if (self.locations[i].criteria === "exclude") {
                self.locations[i].criteria_link = "excluded";
              } else {
                self.locations[i].criteria_link = ""; // Default when criteria is not set or unrecognized
              }

              // Push to navAdwordsLocations and perform checks
              self.navAdwordsLocations.push(self.locations[i]);
              self.checkingCriteria();
            }
          }

          // Save previous state
          self.previousLocationData = angular.copy(self.navAdwordsLocations);
        }
        self.breadcrumbs = [];
        self.buildBreadcrumbs(item);
      }
    };

    self.changeIncludeExclude = function (item, criteria) {
      let includedItems = self.navAdwordsLocations.filter(
        (location) => location.criteria === "include"
      );

      // Step 2: Reset criteria for all locations to 'exclude', except for those already 'include'
      self.navAdwordsLocations.forEach((location) => {
        // If the location is not part of the included items, set criteria to 'exclude'
        if (!includedItems.includes(location)) {
          location.criteria = "exclude";
          location.criteria_link = "excluded";
        }
      });

      // Step 3: Find the index of the selected item in navAdwordsLocations
      var index = self.navAdwordsLocations.indexOf(item);
      if (index >= 0) {
        if (criteria == "include") {
          self.navAdwordsLocations[index].criteria = "include";
          self.navAdwordsLocations[index].criteria_link = "included";
        } else if (criteria == "exclude") {
          self.navAdwordsLocations[index].criteria = "exclude";
          self.navAdwordsLocations[index].criteria_link = "excluded";
        } else {
          self.navAdwordsLocations[index].criteria = "";
          self.navAdwordsLocations[index].criteria_link = "include";
        }
        if (geoLocationsCount < 1) {
          self.includeOrExcludeLocation = criteria + "location";
        }
        var selIndex = _.findIndex(
          self.selectedGeoLocations.selAdwordsLocationPickers,
          function (selected) {
            return (
              selected.name === self.navAdwordsLocations[index].name &&
              selected.type === self.navAdwordsLocations[index].type &&
              selected.country_code ===
                self.navAdwordsLocations[index].country_code &&
              (!self.navAdwordsLocations[index].parent_name ||
                selected.parent_name ===
                  self.navAdwordsLocations[index].parent_name) &&
              (!self.navAdwordsLocations[index].parent_region_name ||
                selected.parent_region_name ===
                  self.navAdwordsLocations[index].parent_region_name) &&
              (!self.navAdwordsLocations[index].code ||
                selected.code === self.navAdwordsLocations[index].code)
            );
          }
        );
        self.navAdwordsLocations[index].full_name = self.buildFullName(
          self.navAdwordsLocations[index]
        );
        if (selIndex > 0) {
          self.selectedGeoLocations.selAdwordsLocationPickers[selIndex] =
            self.navAdwordsLocations[index];
        } else {
          self.selectedGeoLocations.selAdwordsLocationPickers.push(
            self.navAdwordsLocations[index]
          );
        }
        changeAllChildCriteria(
          self.navAdwordsLocations[index].id,
          self.navAdwordsLocations[index].criteria
        );
        for (
          var i = 0;
          i < self.selectedGeoLocations.selAdwordsLocationPickers.length;
          i++
        ) {
          var parentId = parseInt(
            self.selectedGeoLocations.selAdwordsLocationPickers[i].parent_id
          );
          var parentObj = _.find(self.locations, { id: parentId });

          if (
            parentObj &&
            parentObj.criteria ===
              self.selectedGeoLocations.selAdwordsLocationPickers[i].criteria
          ) {
            self.selectedGeoLocations.selAdwordsLocationPickers.splice(i, 1);
          }
        }
        geoLocationsCount++;
      }
    };

    $rootScope.removeLoc = function (item) {
      var selIndex =
        self.selectedGeoLocations.selAdwordsLocationPickers.indexOf(item);
      if (selIndex >= 0) {
        self.selectedGeoLocations.selAdwordsLocationPickers.splice(selIndex, 1);
        if (self.selectedGeoLocations.selAdwordsLocationPickers.length === 0) {
          geoLocationsCount = 0;
          self.includeOrExcludeLocation = null;
        }
      }

      for (var k = 0; k < self.navAdwordsLocations.length; k++) {
        if (
          self.navAdwordsLocations[k].name === item.name &&
          self.navAdwordsLocations[k].type === item.type &&
          self.navAdwordsLocations[k].country_code === item.country_code &&
          (self.navAdwordsLocations[k].parent_name === item.parent_name ||
            !item.parent_name) &&
          (self.navAdwordsLocations[k].parent_region_name ===
            item.parent_region_name ||
            !item.parent_region_name) &&
          (self.navAdwordsLocations[k].code === item.code || !item.code) &&
          (self.navAdwordsLocations[k].value_num === item.value_num ||
            !item.value_num)
        ) {
          // Update the location's criteria to 'exclude' and criteria_link to 'excluded'
          self.navAdwordsLocations[k].criteria = "exclude";
          self.navAdwordsLocations[k].criteria_link = "excluded";
          break;
        }
      }

      self.previousLocationData = angular.copy(self.navAdwordsLocations);
    };

    function changeAllChildCriteria(parentId, criteria = "") {
      var visitedLocations = new Set(); // Set to track already processed locations

      // Avoid unnecessary recursive calls by using a visited locations set
      function recursiveChange(location) {
        if (visitedLocations.has(location.id)) {
          return; // Prevent processing the same location again
        }

        visitedLocations.add(location.id); // Mark location as visited

        // Update criteria based on the given value
        if (criteria === "include") {
          location.criteria = "include";
          location.criteria_link = "included";
        } else if (criteria === "exclude") {
          location.criteria = "exclude";
          location.criteria_link = "excluded";
        } else {
          location.criteria = "";
          location.criteria_link = "include";
        }

        // Proceed with recursion if there are children
        _.each(self.locations, function (child) {
          if (child.parent_id === location.id) {
            recursiveChange(child); // Call recursively for each child
          }
        });
      }

      // Start the recursion from the parent location
      _.each(self.locations, function (location) {
        if (location.parent_id === parentId) {
          recursiveChange(location);
        }
      });
    }

    //searching loacgtion by Searvices
    self.searchAdwordsLocation = function (geolocSearch) {
      if (event.keyCode != 13) {
        if (geolocSearch.length >= 3) {
          FormService.getTritonSearchlocations(geolocSearch).then(
            function (success) {
              if (success.data && success.data.length > 0) {
                self.searchData = success.data;
                self.navAdwordsLocations = [];

                _.each(self.searchData, function (item) {
                  // Add item to navAdwordsLocations directly with required default properties
                  self.navAdwordsLocations.push({
                    ...item,
                  });
                });
                self.checkingCriteria();
              }
            },
            function (error) {}
          );
        } else {
          if (geolocSearch.length == 0) {
            self.searchData = [];
            self.navAdwordsLocations = [];
            self.navAdwordsLocations = angular.copy(self.previousLocationData);
            self.checkingCriteria();
          }
        }
      } else if (event.keyCode == 8) {
        if (geolocSearch.length == 0) {
          self.searchData = [];
          self.navAdwordsLocations = [];
          self.navAdwordsLocations = angular.copy(self.previousLocationData);
          self.checkingCriteria();
        }
      }
    };
    self.checkingCriteria = function () {
      for (
        var k = 0;
        k < self.selectedGeoLocations.selAdwordsLocationPickers.length;
        k++
      ) {
        for (var j = 0; j < self.navAdwordsLocations.length; j++) {
          const selected =
            self.selectedGeoLocations.selAdwordsLocationPickers[k];
          const location = self.navAdwordsLocations[j];

          // Improved comparison logic
          if (
            location.name === selected.name &&
            location.type === selected.type &&
            location.country_code === selected.country_code &&
            (!selected.parent_name ||
              selected.parent_name === location.parent_name) &&
            (!selected.parent_region_name ||
              selected.parent_region_name === location.parent_region_name) &&
            (!selected.code || selected.code === location.code)
          ) {
            // Update criteria based on selectedGeoLocations
            if (selected.criteria === "include") {
              location.criteria = "include";
              location.criteria_link = "included";
            } else if (selected.criteria === "exclude") {
              location.criteria = "exclude";
              location.criteria_link = "excluded";
            } else {
              location.criteria = "";
              location.criteria_link = "include";
            }
          }
        }
      }
    };

    self.buildBreadcrumbs = function (item) {
      if (item.parent_id || item.parent_id == 0) {
        self.breadcrumbs.unshift(item);
        if (item.parent_id == 0) {
          return false;
        } else {
          var obj = _.find(self.locations, function (loc) {
            return loc.id == item.parent_id;
          });
          self.buildBreadcrumbs(obj);
        }
      }
    };

    self.buildFullName = function (item) {
      if (item.parent_id == 0) {
        return item.name + ".";
      } else {
        var obj = _.find(self.locations, function (loc) {
          return loc.id == item.parent_id;
        });
        if (obj == undefined && item.parent_name) {
          return item.name + " , " + item.parent_name + ".";
        } else {
          return item.name + ", " + self.buildFullName(obj);
        }
      }
    };

    self.openHelperTextPopup = function () {
      $modal
        .open(ModalService.returnModalType("showHelpertexts"))
        .result.then(function (res) {
          var test = res;
        });
    };

    var getLocations = function () {
      FormService.geoLocationsForTriton("NA").then(
        function (success) {
          self.locations = success;
          self.getLocationChilds("NA", self.rootLocation);
        },
        function (error) {
          $ioAlert.show(
            "Error!",
            "Something went wrong here. Please refresh the page to try again",
            "error"
          );
        }
      );
    };

    var initLocations = function () {
      if (self.selectedGeoLocations && !_.isEmpty(self.selectedGeoLocations)) {
        self.selectedGeoLocations = JSON.parse(self.selectedGeoLocations);
        $rootScope.selectedGeoLocations = JSON.parse(self.selectedGeoLocations);
        if (self.showActions) {
          self.editMode = true;
          self.enableViewMode = false;
          getLocations();
        } else {
          self.editMode = false;
          self.enableViewMode = true;
        }
      } else {
        self.selectedGeoLocations = {
          selAdwordsLocationPickers: [],
          enableBidAmount: false,
        };
        $rootScope.selectedGeoLocations = self.selectedGeoLocations;
        self.enableViewMode = false;
        self.editMode = false;
        getLocations();
      }
    };

    initLocations();
  },
});
